<div class="nudge" *ngIf="visible" role="note">
  <ion-icon class="nudge__icon" name="calendar-outline" aria-hidden="true"></ion-icon>
  <div class="nudge__body">
    <span class="nudge__headline">Adjusting a lot?</span>
    <span class="nudge__benefit">Set up scheduled sleep and wake temps. <button class="nudge__cta" type="button" aria-label="Set up auto schedule" (click)="setUp()">Set up</button></span>
  </div>
  <button
    class="nudge__dismiss"
    type="button"
    aria-label="Dismiss auto schedule reminder"
    (click)="onDismiss($event)"
  >
    <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
  </button>
</div>
